import { render, staticRenderFns } from "./Order-notes-Ticket.vue?vue&type=template&id=5f172ead"
import script from "./Order-notes-Ticket.vue?vue&type=script&lang=js"
export * from "./Order-notes-Ticket.vue?vue&type=script&lang=js"
import style0 from "./Order-notes-Ticket.vue?vue&type=style&index=0&id=5f172ead&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports